import React from 'react';
import PropTypes from 'prop-types';
import advertisersStrings from 'modules/advertisers/strings';

import {
  Wrapper,
  GridWrapper,
  Header,
  Divider,
  ItemColumn,
  ItemRow,
  ItemText,
  ItemBtn,
} from './AdvertisersList.style';

const AdvertisersList = ({
  advertisersListArr,
  handleEditAdvertiserBtnClick,
  handleAddCampaignBtnClick,
  handleViewCampaignsBtnClick,
}) => {
  const advertisersGridHeaderList = advertisersStrings.advertisersList.advertisersGridHeader;

  return (
    <Wrapper>
      <GridWrapper>
        <Divider />
        {Object.keys(advertisersGridHeaderList).map(advertisersGridHeaderKey => (
          <Header key={advertisersGridHeaderKey}>
            {advertisersGridHeaderList[advertisersGridHeaderKey]}
          </Header>
        ))}
        <Divider />
        {advertisersListArr.map((advertiser, index) => {
          const isLastItem = index === advertisersListArr.length - 1;

          return (
            <React.Fragment key={advertiser.advertiserKey}>
              <ItemColumn>
                <ItemText>{advertiser.name}</ItemText>
              </ItemColumn>
              <ItemColumn>
                <ItemText>{advertiser.phone}</ItemText>
              </ItemColumn>
              <ItemColumn>
                <ItemText>{advertiser.email}</ItemText>
              </ItemColumn>
              <ItemRow>
                <ItemBtn
                  as="button"
                  icon={'"\\e905"'}
                  onClick={() => handleViewCampaignsBtnClick(advertiser.advertiserKey)}
                />
                <ItemBtn
                  as="button"
                  icon={'"\\e910"'}
                  onClick={() => handleAddCampaignBtnClick(advertiser.advertiserKey)}
                />
                <ItemBtn
                  as="button"
                  icon={'"\\e90a"'}
                  onClick={() => handleEditAdvertiserBtnClick(advertiser)}
                />
              </ItemRow>
              {isLastItem === false && <Divider />}
            </React.Fragment>
          );
        })}
      </GridWrapper>
    </Wrapper>
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

AdvertisersList.propTypes = {
  advertisersListArr: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleEditAdvertiserBtnClick: PropTypes.func.isRequired,
  handleAddCampaignBtnClick: PropTypes.func.isRequired,
  handleViewCampaignsBtnClick: PropTypes.func.isRequired,
};

AdvertisersList.defaultProps = {};

export default AdvertisersList;
